<template>
  <div class="add-adress-container">
    <van-address-edit
      :area-list="areaList"
      show-set-default
      :address-info="AddressInfo"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import api from '../api/index-client'
import { AddressEdit } from 'vant';
Vue.use(AddressEdit);
export default {
  data () {
    return {
      cityList: [],
      AddressInfo: {
        id: '',
        name: '',
        tel: '',
        province: '',
        city: '',
        county: '',
        addressDetail: '',
        areaCode: '',
        postalCode: '',
        isDefault: false,
      },
      areaList: {
        province_list: {
        },
        city_list: {
        },
        county_list: {
        },
      },
    }
  },
  mounted () {
    document.getElementsByClassName("van-cell__title")[0].innerHTML = '收货人'
    document.getElementsByClassName("van-cell__title")[1].innerHTML = '联系电话'
    document.getElementsByClassName("van-cell__title")[2].innerHTML = '所在地区'
    this.getCityList()
  },
  methods: {
    getAdressDetails (id) {
      api
        .get('address/detail/' + id)
        .then(result => {
          if (result.data.success) {
            this.AddressInfo = {
              id: result.data.data.id,
              name: result.data.data.realName,
              tel: result.data.data.phone,
              province: result.data.data.province,
              city: result.data.data.city,
              county: result.data.data.district,
              addressDetail: result.data.data.detail,
              areaCode: '',
              postalCode: '',
              isDefault: result.data.data.isDefault == 1 ? true : false,
            }
            if (result.data.data.province == "香港特别行政区") {
              this.cityList.map((i) => {
                if (i.n == result.data.data.province) {
                  i.c.map((j,index1) => {
                    if (j.n == result.data.data.city) {
                      this.AddressInfo.postalCode = `81` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + `00`
                      j.c.map((m,index2) => {
                        if (m.n == result.data.data.district) {
                          this.AddressInfo.areaCode = `81` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)
                        }
                      })
                    }
                  })
                }
              })
            } else if (result.data.data.province == "澳门特别行政区") {
              this.cityList.map((i) => {
                if (i.n == result.data.data.province) {
                  i.c.map((j,index1) => {
                    if (j.n == result.data.data.city) {
                      this.AddressInfo.postalCode = `82` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + `00`
                      j.c.map((m,index2) => {
                        if (m.n == result.data.data.district) {
                          this.AddressInfo.areaCode = `82` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)
                        }
                      })
                    }
                  })
                }
              })
            } else if (result.data.data.province == "台湾") {
              this.cityList.map((i) => {
                if (i.n == result.data.data.province) {
                  i.c.map((j,index1) => {
                    if (j.n == result.data.data.city) {
                      this.AddressInfo.postalCode = `91` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + `00`
                      j.c.map((m,index2) => {
                        if (m.n == result.data.data.district) {
                          this.AddressInfo.areaCode = `91` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)
                        }
                      })
                    }
                  })
                }
              })
            } else {
              this.cityList.map((i) => {
                if (i.n == result.data.data.province) {
                  i.c.map((j) => {
                    if (j.n == result.data.data.city) {
                      this.AddressInfo.postalCode = j.code
                      j.c.map(m => {
                        if (m.n == result.data.data.district) {
                          this.AddressInfo.areaCode = m.code
                        }
                      })
                    }
                  })
                }
              })
            }
            console.log(this.cityList);
          } else {
            this.$toast({
              message: result.data.msg,
              icon: require('../assets/icon/toast-error.png'),
            });
          }
        })
    },
    // 保存地址
    onSave (content) {
      console.log(content);
      var param = {
        id: this.$route.query.id ? this.$route.query.id : null,
        real_name: content.name,
        phone: content.tel,
        address: {
          city_id: null,
          city: content.areaCode.substring(0,2) == '91' ? content.country : content.city,
          district: content.areaCode.substring(0,2) == '91' ? content.province : content.county,
          province: content.areaCode.substring(0,2) == '91' ? "台湾" : content.province
        },
        detail: content.addressDetail,
        is_default: content.isDefault ? '1' : '0',
      }
      this.cityList.map((i) => {
        if (i.n == content.province) {
          i.c.map((j) => {
            if (j.n == content.city) {
              param.address.city_id = j.pid
            }
          })
        }
      })
      // 保存
      api
        .post('address/edit',param)
        .then(result => {
          if (result.data.success) {
            this.$toast.success('成功')
            if (this.$route.query.from == 'conversion') {
              this.$router.replace('/conversion')
            } else {
              this.$router.replace('/adressManage')
            }

          } else {
            this.$toast({
              message: result.data.msg,
              icon: require('../assets/icon/toast-error.png'),
            });
          }
        })
    },
    // 获取城市信息
    getCityList () {
      api
        .get('city_list')
        .then(result => {
          if (result.data.success) {
            let arr = result.data.data
            this.cityList = result.data.data
            if (this.$route.query.id) {
              this.getAdressDetails(this.$route.query.id)
            }
            this.areaList = {
              province_list: {
              },
              city_list: {
              },
              county_list: {
              },
            };
            result.data.data.map(i => {
              if (i.n == "香港特别行政区") {
                this.areaList.province_list['810000'] = i.n
                i.c.map((j,index1) => {
                  this.areaList.city_list[`81` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + `00`] = j.n
                  j.c.map((m,index2) => {
                    this.areaList.county_list[`81` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)] = m.n
                  })
                })
              } else if (i.n == "澳门特别行政区") {
                this.areaList.province_list['820000'] = i.n
                i.c.map((j,index1) => {
                  this.areaList.city_list[`82` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + `00`] = j.n
                  j.c.map((m,index2) => {
                    this.areaList.county_list[`82` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)] = m.n
                  })
                })
              } else if (i.n == "台湾") {
                this.areaList.province_list['910000'] = i.n
                i.c.map((j,index1) => {
                  this.areaList.city_list[`91` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + `00`] = j.n
                  j.c.map((m,index2) => {
                    this.areaList.county_list[`91` + ((String(index1 + 1)).length == 1 ? `0` : ``) + String(index1 + 1) + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)] = m.n
                  })
                })
              } else if (i.n == "广东省") {
                this.areaList.province_list[i.code] = i.n
                i.c.map((j,index1) => {
                  this.areaList.city_list[j.code] = j.n
                  if (j.n == "东莞市") {
                    j.c.map((m,index2) => {
                      this.areaList.county_list[`4419` + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)] = m.n
                    })
                  } else if (j.n == "中山市") {
                    j.c.map((m,index2) => {
                      this.areaList.county_list[`4420` + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)] = m.n
                    })
                  } else {
                    j.c.map((m,index2) => {
                      this.areaList.county_list[m.code] = m.n
                    })
                  }
                })
              } else if (i.n == "海南省") {
                this.areaList.province_list[i.code] = i.n
                i.c.map((j,index1) => {
                  this.areaList.city_list[j.code] = j.n
                  if (j.n == "儋州市") {
                    j.c.map((m,index2) => {
                      this.areaList.county_list[`4604` + ((String(index2 + 1)).length == 1 ? `0` : ``) + String(index2 + 1)] = m.n
                    })
                  } else {
                    j.c.map((m,index2) => {
                      this.areaList.county_list[m.code] = m.n
                    })
                  }
                })
              } else {
                this.areaList.province_list[i.code] = i.n
                i.c.map(j => {
                  this.areaList.city_list[j.code] = j.n
                  j.c.map(m => {
                    this.areaList.county_list[m.code] = m.n
                  })
                })
              }
            })
            this.$store.commit('HIDE_APPLOADING')
          } else {
            this.$toast({
              message: result.data.msg,
              icon: require('../assets/icon/toast-error.png'),
            });
          }
        })
    },
  },
}
</script>
<style lang="less" scoped>
.add-adress-container {
  margin-top: 3.875rem;
  height: calc(100vh - 3.875rem);
  overflow-y: auto;
  width: 100%;
  z-index: 19;
  /deep/.van-cell {
    background-color: #1c1c1c;
    margin-bottom: 6px;
  }
  /deep/.van-cell::after {
    display: none;
  }
  /deep/.van-cell__title {
    font-size: 1rem;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    padding-top: 10px;
    color: #fefefe;
  }
  /deep/.van-field__value {
    height: 45px;
    background: #262626;
    border-radius: 4px;
  }
  /deep/.van-field__body {
    margin-top: 10px;
    margin-left: 21px;
  }
  /deep/.van-field__right-icon {
    margin-right: 10px;
  }
  /deep/.van-address-edit-detail
    .van-cell__value
    .van-cell
    .van-field__value
    .van-field__body {
    height: 95px;
    display: block;
    overflow-y: auto;
    margin-right: 10px;
    margin-bottom: 16px;
  }
  /deep/.van-address-edit-detail .van-cell__value .van-cell .van-field__value {
    height: 110px;
  }
  /deep/.van-address-edit__buttons {
    padding: 12px 16px;
  }
  /deep/.van-address-edit__buttons .van-button {
    height: 46px;
    background-image: url('../assets/icon/confirm-button.png');
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: 0% 0%;
    background-color: transparent;
    font-size: 1rem;
    font-family: lantingheiweight;
    font-weight: normal;
    color: #ffffff;
    line-height: 1.375rem;
    letter-spacing: 2px;
    cursor: pointer;
    background-size: cover;
    border-radius: 0;
    border: none;
  }
  /deep/.van-field__control {
    font-size: 15px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #a3a3a3;
  }
  /deep/.van-icon-clear {
    margin-right: 10px;
  }
  /deep/.van-switch--on {
    background-color: #9742c0;
  }
  /deep/.van-address-edit__default {
    margin-top: 0px;
  }
}
</style>